import { schema } from 'normalizr';
import learningCourseVariant from './learningCourseVariant';
import labelSchema from './label';
import memberSchema from './member';

const learningCourseSchema = new schema.Entity('learningCourses', {
  variants: [learningCourseVariant],
  defaultVariant: learningCourseVariant,
  targets: [labelSchema],
  optionalTargets: [labelSchema],
  managers: [memberSchema],
});

export default learningCourseSchema;
